import script from "./LeftLine2.vue?vue&type=script&setup=true&lang=js"
export * from "./LeftLine2.vue?vue&type=script&setup=true&lang=js"

export default script